import DateType from '@/constants/DateType';
import translate from '@/lib/intl/translate';

const DateTypeOptions = [
  {
    value: '',
    label: translate('REPORTS_FILTER_DATE_TYPE_ALL_TIME'),
  },
  {
    value: DateType.CALENDAR_YTD,
    label: translate('FORMS_DATE_TYPE_CALENDAR_YTD'),
  },
  {
    value: DateType.LAST_MONTH,
    label: translate('FORMS_DATE_TYPE_LAST_MONTH'),
  },
  {
    value: DateType.LAST_6_MONTHS,
    label: translate('FORMS_DATE_TYPE_LAST_6_MONTHS'),
  },
  {
    value: DateType.LAST_12_MONTHS,
    label: translate('FORMS_DATE_TYPE_LAST_12_MONTHS'),
  },
  {
    value: DateType.CUSTOM_DATES,
    label: translate('FORMS_DATE_TYPE_CUSTOM_DATES'),
  },
];

export default DateTypeOptions;
